import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {Image} from '@jobseeker/lotus/components/Image';
import {ChevronRight} from '@jobseeker/lotus/icons';

const LINKEDIN_BLUE = '#0A66C2';

export interface LinkedInSyncTileProps {
  onClick: () => void;
}

const LinkedInSyncTile = ({onClick}: LinkedInSyncTileProps) => (
  <Box
    component="button"
    type="button"
    onClick={onClick}
    data-testid="jobfeed-linkedin-sync-tile"
    data-component="LinkedInSyncTile"
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: '9px',
      width: '100%',
      mt: '14px',
      p: '10px 10px',
      border: '1px solid #49966E',
      borderRadius: '8px',
      bgcolor: 'transparent',
      font: 'inherit',
      textAlign: 'left',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease, border-color 0.2s ease',
      '&:focus-visible': {
        outline: `2px solid ${LINKEDIN_BLUE}`,
        outlineOffset: '2px',
      },
    }}
  >
    <Box
      aria-hidden="true"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'none',
        width: 20,
        height: 20,
        borderRadius: '5px',
        bgcolor: LINKEDIN_BLUE,
        color: '#fff',
        fontSize: 10,
        fontWeight: 700,
        lineHeight: 1,
      }}
    >
      in
    </Box>

    <Box sx={{flex: 1, minWidth: 0}}>
      <Typography
        sx={{
          fontSize: 13,
          fontWeight: 600,
          color: '#22303A',
          lineHeight: 1.55,
        }}
      >
        Sync with LinkedIn
      </Typography>
      <Typography
        sx={{
          fontSize: 10,
          color: '#7A868E',
          lineHeight: 1.35,
          mt: '1px',
        }}
      >
        Never update your profile manually again
      </Typography>
    </Box>

    <Box sx={{flex: 'none', display: 'flex', alignItems: 'center'}}>
      <Image
        src={ChevronRight}
        alt={'Arrow'}
        width={10}
        height={10}
        objectFit="cover"
      />
    </Box>
  </Box>
);

export default LinkedInSyncTile;
